import React from "react";
import { ArrowRight, AlertCircle } from "lucide-react";
import { commonIssues, PHONE_TEL } from "../mock";

const CommonIssues = () => (
  <section className="bg-[#ece9f8] py-24">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <div>
          <p className="reveal text-xs font-semibold tracking-[0.22em] uppercase text-[#7c3aed] mb-4">
            Sound Familiar?
          </p>
          <h2 className="reveal font-display text-4xl lg:text-5xl font-semibold text-[#1e183a] leading-tight">
            Common issues we solve daily.
          </h2>
        </div>
        <a
          href={`tel:${PHONE_TEL}`}
          className="reveal inline-flex items-center gap-1.5 text-[#7c3aed] font-semibold hover:gap-2.5 transition-all"
        >
          Not listed? Call us anyway <ArrowRight className="w-4 h-4" />
        </a>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {commonIssues.map((issue) => (
          <div
            key={issue.title}
            className="reveal group rounded-2xl bg-white border border-[#1e183a]/8 p-6 transition-all duration-300 hover:border-[#7c3aed]/40 hover:-translate-y-1"
          >
            <AlertCircle className="w-6 h-6 text-[#7c3aed] mb-4" strokeWidth={2.2} />
            <h3 className="font-display text-lg font-semibold text-[#1e183a] leading-snug">
              {issue.title}
            </h3>
            <p className="mt-2 text-sm text-[#1e183a]/60 leading-relaxed">{issue.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CommonIssues;
